module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_smaller-c35d4fd88037db030913252bffb6cf63.svg";